import { useEffect, useRef, useState } from "react";

import history2023Img1 from "@/assets/images/user/history2023Img1.jpg";
import history2023Img2 from "@/assets/images/user/history2023Img2.jpg";
import history2023Img3 from "@/assets/images/user/history2023Img3.jpg";
import history2023Img4 from "@/assets/images/user/history2023Img4.jpg";
import history2023Img5 from "@/assets/images/user/history2023Img5.jpg";
import history2023Img6 from "@/assets/images/user/history2023Img6.jpg";
import history2023Img7 from "@/assets/images/user/history2023Img7.jpg";
import history2023Img8 from "@/assets/images/user/history2023Img8.jpg";
import history2023Img9 from "@/assets/images/user/history2023Img9.jpg";
import history2023Img10 from "@/assets/images/user/history2023Img10.jpg";
import history2023Img11 from "@/assets/images/user/history2023Img11.jpg";
import history2023Img12 from "@/assets/images/user/history2023Img12.jpg";
import history2023Poster from "@/assets/images/user/history2023Poster.jpg";
import history2024Img1 from "@/assets/images/user/history2024Img1.jpg";
import history2024Img2 from "@/assets/images/user/history2024Img2.jpg";
import history2024Img3 from "@/assets/images/user/history2024Img3.jpg";
import history2024Img4 from "@/assets/images/user/history2024Img4.jpg";
import history2024Img5 from "@/assets/images/user/history2024Img5.jpg";
import history2024Img6 from "@/assets/images/user/history2024Img6.jpg";
import history2024Img7 from "@/assets/images/user/history2024Img7.jpg";
import history2024Img8 from "@/assets/images/user/history2024Img8.jpg";
import history2024Img9 from "@/assets/images/user/history2024Img9.jpg";
import history2024Img10 from "@/assets/images/user/history2024Img10.jpg";
import history2024Img11 from "@/assets/images/user/history2024Img11.jpg";
import history2024Img12 from "@/assets/images/user/history2024Img12.jpg";
import history2024Poster from "@/assets/images/user/history2024Poster.jpg";
import icPause from "@/assets/images/user/icPause.svg";
import icPlay from "@/assets/images/user/icPlay.svg";
import programArt from "@/assets/images/user/programArt.svg";
import programFesta from "@/assets/images/user/programFesta.svg";
import programPlay from "@/assets/images/user/programPlay.svg";
import programShow from "@/assets/images/user/programShow.svg";
import programSpeech from "@/assets/images/user/programSpeech.svg";
import programStage from "@/assets/images/user/programStage.svg";
import programStay from "@/assets/images/user/programStay.svg";
import { Dialog, DialogTrigger } from "@/components/ui/dialog";
import { ScrollArea } from "@/components/ui/scroll-area";
import ProgramAccordion from "@/components/user/common/ProgramAccordion";
import SubTitle from "@/components/user/common/SubTitle";
import TitleBox from "@/components/user/common/TitleBox";
import ImgPop from "@/components/user/popup/ImgPop";

declare global {
    interface Window {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        YT: any;
        onYouTubeIframeAPIReady: () => void;
    }
}

const program2024List = [
    {
        title: "무대 프로그램",
        background: "bg-program202401",
        img: programStage,
        contents: (
            <p>
                게임OST 국악 콘서트&nbsp;&nbsp;I&nbsp;&nbsp;GXG 2024 개막식&축하 공연
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>게임음악 경연대회
                <br className="hidden md:block" />
                <span className="md:hidden">&nbsp;&nbsp;I&nbsp;&nbsp;</span>일러스타 페스 스테이지
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span> WCG 스테이지
                &nbsp;&nbsp;I&nbsp;&nbsp;GXG 2024 갈라 콘서트
            </p>
        ),
    },
    {
        title: "전시형 프로그램",
        background: "bg-program202402",
        img: programArt,
        contents: <p>브랜드 체험존&nbsp;&nbsp;I&nbsp;&nbsp;GXG 마켓&nbsp;&nbsp;I&nbsp;&nbsp;버스킹 라운지</p>,
    },
    {
        title: "참여형 프로그램",
        background: "bg-program202403",
        img: programPlay,
        contents: <p>게임문화전시&nbsp;&nbsp;I&nbsp;&nbsp;사회공헌전시&nbsp;&nbsp;I&nbsp;&nbsp;테라시아 특별전</p>,
    },
    {
        title: "GXG 콜라보레이션",
        background: "bg-program202404",
        img: programFesta,
        contents: (
            <p>GXG x 인디크래프트&nbsp;&nbsp;I&nbsp;&nbsp;GXG x WCG&nbsp;&nbsp;I&nbsp;&nbsp;GXG x 일러스타 페스</p>
        ),
    },
];

const program2023List = [
    {
        title: "무대 프로그램",
        background: "bg-program202301",
        img: programStage,
        contents: (
            <p>
                개막 기념 창작 뮤지컬 <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>
                GXG 2023 개막식 & 축하 공연<span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>
                <br className="md:hidden" />
                게임 기업 직장인 동아리 밴드 공연 <br />
                게임 OST 오케스트라&nbsp;&nbsp;I&nbsp;&nbsp;코스프레 포토타임
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>
                게임 경매 이벤트&nbsp;&nbsp;I&nbsp;&nbsp;뚱종원(나선욱)의 겜쿡비책
                <br />
                성남 청년 버스킹 공연 (2023 성남 청년 문화 축제)
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>2023 게임제너레이션
                게임비평공모전 시상식
            </p>
        ),
    },
    {
        title: "전시・체험 프로그램",
        background: "bg-program202302",
        img: programShow,
        contents: (
            <p>
                기업 참여 전시&nbsp;&nbsp;I&nbsp;&nbsp;사회공헌전시&nbsp;&nbsp;I&nbsp;&nbsp;라이징 인디게임존
                <br />
                나승훈 웹툰작가 : 라이브 드로잉
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>흑요석 작가 : 팬사인회
            </p>
        ),
    },
    {
        title: "컨퍼런스 프로그램",
        background: "bg-program202303",
        img: programSpeech,
        contents: (
            <p>
                문화예술분야 연사 참여 컨퍼런스 (세상무대 / 상상무대)
                <br />
                라이징 인디게임 시상식
                <br className="md:hidden" />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>
                2023 신구대학교 전국 중고교생 게임 공모전
            </p>
        ),
    },
    {
        title: "네트워킹 프로그램",
        background: "bg-program202304",
        img: programStay,
        contents: (
            <p>
                게임 문화인 대상 오픈형 네트워킹 공간
                <br className="md:hidden " />
                <span className="hidden md:inline-block">&nbsp;&nbsp;I&nbsp;&nbsp;</span>Microsoft Korea & 띵스플로우
                전시
            </p>
        ),
    },
];

const program2024ImgList = [
    { title: "GXG 2024 전경", img: history2024Img1 },
    { title: "GXG 2024 개막식", img: history2024Img2 },
    { title: "The 1st GXG SOUND TRACK", img: history2024Img3 },
    { title: "GXG 2024 갈라 콘서트", img: history2024Img4 },
    { title: "게임문화전시", img: history2024Img5 },
    { title: "브랜드 체험존", img: history2024Img6 },
    { title: "GXG 마켓", img: history2024Img7 },
    { title: "GXG 이벤트존", img: history2024Img8 },
    { title: "GXG 버스킹 라운지", img: history2024Img9 },
    { title: "GXG x 인디크래프트", img: history2024Img10 },
    { title: "GXG x 일러스타페스", img: history2024Img11 },
    { title: "GXG x WCG", img: history2024Img12 },
];

const program2023ImgList = [
    { title: "GXG 2023 전경", img: history2023Img1 },
    { title: "GXG 2023 실내 전경", img: history2023Img2 },
    { title: "GXG 2023 현장 스케치", img: history2023Img3 },
    { title: "GXG 2023 개막식", img: history2023Img4 },
    { title: "게임OST 오케스트라 콘서트", img: history2023Img5 },
    { title: "코스프레 콘테스트", img: history2023Img6 },
    { title: "부대 프로그램", img: history2023Img7 },
    { title: "브랜드 전시/체험", img: history2023Img8 },
    { title: "THE SHOW 라이브 드로잉", img: history2023Img9 },
    { title: "THE SHOW 팬사인회", img: history2023Img10 },
    { title: "THE SPEECH 세상무대", img: history2023Img11 },
    { title: "THE SPEECH 상상무대", img: history2023Img12 },
];

export default function History() {
    const [isPlaying, setIsPlaying] = useState(false);
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const playerRef = useRef<any>(null);
    const playerContainerRef = useRef<HTMLDivElement>(null);

    useEffect(() => {
        // YouTube API 로드
        const tag = document.createElement("script");
        tag.src = "https://www.youtube.com/iframe_api";
        const firstScriptTag = document.getElementsByTagName("script")[0];
        firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);

        // API 준비되면 플레이어 생성
        window.onYouTubeIframeAPIReady = () => {
            if (playerContainerRef.current) {
                playerRef.current = new window.YT.Player(playerContainerRef.current, {
                    height: "100%",
                    width: "100%",
                    videoId: "csUOprB7oxQ",
                    playerVars: {
                        autoplay: 0,
                        controls: 0,
                        rel: 0,
                        showinfo: 0,
                        modestbranding: 1,
                    },
                    events: {
                        onStateChange: onPlayerStateChange,
                    },
                });
            }
        };

        return () => {
            if (playerRef.current) {
                playerRef.current.destroy();
            }
        };
    }, []);

    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const onPlayerStateChange = (event: any) => {
        // 1: 재생 중, 2: 일시정지, 0: 종료
        if (event.data === 1) {
            setIsPlaying(true);
        } else if (event.data === 2 || event.data === 0) {
            setIsPlaying(false);
        }
    };

    const togglePlay = () => {
        if (playerRef.current) {
            if (isPlaying) {
                playerRef.current.pauseVideo();
            } else {
                playerRef.current.playVideo();
            }
        }
    };

    return (
        <div className="px-[20px] xl:px-0">
            <section className="max-w-[1400px] w-full mx-auto pb-[60px] md:pb-[80px]">
                <TitleBox title="GXG HISTORY" text="GXG 2024 다시보기" />
                <div className="pt-[40px] md:pt-[60px] xl:flex xl:gap-[52px]">
                    <div>
                        <img src={history2024Poster} alt="GXG 2024" />
                    </div>
                    <div className="pt-[40px] w-full md:pt-[60px] xl:pt-0 xl:flex-1 xl:flex xl:flex-col xl:justify-between">
                        <ul className="flex flex-col gap-[12px] md:gap-[16px]">
                            <li className="flex items-center gap-[12px] md:gap-[16px]">
                                <p className="max-w-[72px] w-full text-[18px] py-[2px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[38px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[4px]">
                                    {"행사명"}
                                </p>
                                <p className="text-[16px] font-medium text-black flex-1 font-['GongGothicLight'] leading-[1.8] md:text-[20px]">
                                    GXG 2024 <br className="md:hidden" />
                                    <span className="text-[14px] md:text-[20px]">(Game culture X Generation 2024)</span>
                                </p>
                            </li>
                            <li className="flex items-center gap-[12px] md:gap-[16px]">
                                <p className="max-w-[72px] w-full text-[18px] py-[2px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[38px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[4px]">
                                    {"일  정"}
                                </p>
                                <p className="text-[16px] font-medium text-black flex-1 font-['GongGothicLight'] leading-[1.8] md:text-[20px]">
                                    2024년 9월 6일(금)~7일(토)
                                </p>
                            </li>
                            <li className="flex items-center gap-[12px] md:gap-[16px]">
                                <p className="max-w-[72px] w-full text-[18px] py-[2px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[38px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[4px]">
                                    {"장  소"}
                                </p>
                                <p className="text-[16px] font-medium text-black flex-1 font-['GongGothicLight'] leading-[1.8] md:text-[20px]">
                                    경기도 성남시 판교역 일대
                                </p>
                            </li>
                            <li className="flex items-center gap-[12px] md:gap-[16px]">
                                <p className="max-w-[72px] w-full text-[18px] py-[2px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[38px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[4px]">
                                    {"주  최"}
                                </p>
                                <p className="text-[16px] font-medium text-black flex-1 font-['GongGothicLight'] leading-[1.8] md:text-[20px]">
                                    성남시
                                </p>
                            </li>
                            <li className="flex items-center gap-[12px] md:gap-[16px]">
                                <p className="max-w-[72px] w-full text-[18px] py-[2px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[38px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[4px]">
                                    {"주  관"}
                                </p>
                                <p className="text-[16px] font-medium text-black flex-1 font-['GongGothicLight'] leading-[1.8] md:text-[20px]">
                                    성남산업진흥원, 게임문화재단
                                </p>
                            </li>
                            <li className="flex items-start gap-[12px] md:gap-[16px]">
                                <p className="max-w-[72px] w-full text-[18px] py-[2px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[38px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[4px]">
                                    {"후  원"}
                                </p>
                                <p className="text-[14px] font-medium text-black flex-1 font-['GongGothicLight'] leading-[1.8] md:text-[20px]">
                                    문화체육관광부, 한국콘텐츠진흥원, <br className="md:hidden" />
                                    게임물관리위원회, <br className="hidden xl:block" />
                                    성남시청소년재단, <br className="xl:hidden" />
                                    넥슨코리아, 엔씨소프트, 슈퍼셀, 펄어비스,{` `} <br className="hidden xl:block" />
                                    레드프린팅 앤 프레스, <br className="hidden md:block xl:hidden" />
                                    스튜디오메타케이, <br className="md:hidden" />
                                    이모션웨이브, 판교 테크원
                                </p>
                            </li>
                        </ul>
                        <div>
                            <p className="text-[24px] font-['GongGothicMedium'] leading-[28px] text-black p-[40px_0_12px] xl:p-[20px_0]">
                                프로그램
                            </p>
                            <ProgramAccordion list={program2024List} />
                        </div>
                    </div>
                </div>
            </section>
            <section className="max-w-[1400px] w-full mx-auto pb-[60px] md:pb-[80px]">
                <SubTitle title="하이라이트 (2024)" className="pb-[24px] md:pb-[40px]" />
                <div className="relative h-[200px] overflow-hidden rounded-[20px_0_20px_0] border-2 border-transparent bg-origin-border shadow-[8px_8px_0_0_#D456A0] bg-gradient-to-br from-[#E64C88] to-[#3734C3] md:rounded-[60px_0_60px_0] md:border-4 md:shadow-[16px_16px_0_0_#D456A0] group md:h-[400px] xl:h-[720px]">
                    <div ref={playerContainerRef} className="w-full h-full" />
                    <button
                        type="button"
                        onClick={togglePlay}
                        className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 size-[140px] opacity-0 flex-col items-center gap-[8px] pt-[40px] rounded-full transition-all group-hover:opacity-100 bg-videoBtnBg hidden md:flex"
                    >
                        <img src={isPlaying ? icPause : icPlay} alt="동영상버튼" />
                        <p className="font-['Handjet'] text-white text-[20px]">{isPlaying ? "PAUSE" : "PLAY"}</p>
                    </button>
                </div>
            </section>
            <section className="max-w-[1400px] w-full mx-auto pb-[120px] md:pb-[160px]">
                <SubTitle title="현장스케치 (2024)" className="pb-[24px] md:pb-[40px]" />
                <ul className="grid grid-cols-1 gap-[28px] md:grid-cols-2 md:gap-y-[40px] md:gap-x-[24px] xl:grid-cols-4">
                    {program2024ImgList.map((img, i) => (
                        <li key={`img_${i}`}>
                            <Dialog>
                                <DialogTrigger asChild>
                                    <div className="cursor-pointer">
                                        <div className="group relative w-full h-0 pb-[67%] overflow-hidden transition-all duration-500 before:absolute before:content-[''] before:w-full before:h-full before:border-4 before:border-transparent before:[border-image:linear-gradient(135deg,#E64C88_0%,#3734C3_100%)_1] before:opacity-0 before:transition-all before:duration-500 before:z-[2] before:hover:opacity-100 hover:shadow-[0_0_36px_0_rgba(237,6,115,0.60)]">
                                            <img
                                                src={img.img}
                                                alt={img.title}
                                                className="absolute inset-0 z-[1] w-full h-full object-cover transition-all duration-500 group-hover:scale-[1.2]"
                                            />
                                        </div>
                                        <p className="text-[24px] text-black font-[600] pt-[16px]">{img.title}</p>
                                    </div>
                                </DialogTrigger>
                                <ImgPop title={img.title}>
                                    <ScrollArea className="max-h-[60vh]">
                                        <div className="p-[10px_20px_20px]">
                                            <img src={img.img} alt={img.title} />
                                        </div>
                                    </ScrollArea>
                                </ImgPop>
                            </Dialog>
                        </li>
                    ))}
                </ul>
            </section>
            <section className="max-w-[1400px] w-full mx-auto pb-[60px] md:pb-[80px]">
                <TitleBox title="GXG HISTORY" text="GXG 2023 다시보기" />
                <div className="pt-[40px] md:pt-[60px] xl:flex xl:gap-[52px]">
                    <div>
                        <img src={history2023Poster} alt="GXG 2023" />
                    </div>
                    <div className="pt-[40px] w-full md:pt-[60px] xl:pt-0 xl:flex-1 xl:flex xl:flex-col xl:justify-between">
                        <ul className="flex flex-col gap-[12px] md:gap-[16px]">
                            <li className="flex items-center gap-[12px] md:gap-[16px]">
                                <p className="max-w-[72px] w-full text-[18px] py-[2px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[38px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[4px]">
                                    {"행사명"}
                                </p>
                                <p className="text-[16px] font-medium text-black flex-1 font-['GongGothicLight'] leading-[1.8] md:text-[20px]">
                                    GXG 2023 <br className="md:hidden" />
                                    <span className="text-[14px] md:text-[20px]">(Game culture X Generation 2023)</span>
                                </p>
                            </li>
                            <li className="flex items-center gap-[12px] md:gap-[16px]">
                                <p className="max-w-[72px] w-full text-[18px] py-[2px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[38px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[4px]">
                                    {"일  정"}
                                </p>
                                <p className="text-[16px] font-medium text-black flex-1 font-['GongGothicLight'] leading-[1.8] md:text-[20px]">
                                    2023년 9월 8일(금)~9일(토)
                                </p>
                            </li>
                            <li className="flex items-center gap-[12px] md:gap-[16px]">
                                <p className="max-w-[72px] w-full text-[18px] py-[2px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[38px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[4px]">
                                    {"장  소"}
                                </p>
                                <p className="text-[16px] font-medium text-black flex-1 font-['GongGothicLight'] leading-[1.8] md:text-[20px]">
                                    판교역 광장, 판교 테크원, <br className="md:hidden" />
                                    카카오 판교아지트
                                </p>
                            </li>
                            <li className="flex items-center gap-[12px] md:gap-[16px]">
                                <p className="max-w-[72px] w-full text-[18px] py-[2px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[38px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[4px]">
                                    {"주  최"}
                                </p>
                                <p className="text-[16px] font-medium text-black flex-1 font-['GongGothicLight'] leading-[1.8] md:text-[20px]">
                                    성남시
                                </p>
                            </li>
                            <li className="flex items-center gap-[12px] md:gap-[16px]">
                                <p className="max-w-[72px] w-full text-[18px] py-[2px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[38px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[4px]">
                                    {"주  관"}
                                </p>
                                <p className="text-[16px] font-medium text-black flex-1 font-['GongGothicLight'] leading-[1.8] md:text-[20px]">
                                    성남산업진흥원, 게임문화재단, <br className="md:hidden" />
                                    한국게임산업협회
                                </p>
                            </li>
                            <li className="flex items-start gap-[12px] md:gap-[16px]">
                                <p className="max-w-[72px] w-full text-[18px] py-[2px] font-[500] text-[#000] font-['GongGothicMedium'] text-center leading-[38px] rounded-[8px] shadow-[0_0_12px_0_rgba(221,54,98,0.20)] border border-transparent [background-image:linear-gradient(#fff,#fff),linear-gradient(135deg,#E64C88_0%,#3734C3_100%)] [background-origin:border-box] [background-clip:padding-box,border-box] md:max-w-[120px] md:text-[20px] md:py-[4px]">
                                    {"후  원"}
                                </p>
                                <p className="text-[14px] font-medium text-black flex-1 font-['GongGothicLight'] leading-[1.8] md:text-[20px]">
                                    문화체육관광부, 한국콘텐츠진흥원, <br className="md:hidden" />
                                    넥슨코리아, 엔씨소프트, 판교 테크원, <br className="xl:hidden" />
                                    레드프린팅앤프레스, 맥파이, <br className="md:hidden" />
                                    게임코치 아카데미, 성남시청소년재단
                                </p>
                            </li>
                        </ul>
                        <div>
                            <p className="text-[24px] font-['GongGothicMedium'] leading-[28px] text-black p-[40px_0_12px] xl:p-[20px_0]">
                                프로그램
                            </p>
                            <ProgramAccordion list={program2023List} />
                        </div>
                    </div>
                </div>
            </section>
            <section className="max-w-[1400px] w-full mx-auto pb-[120px] md:pb-[160px]">
                <SubTitle title="현장스케치 (2023)" className="pb-[24px] md:pb-[40px]" />
                <ul className="grid grid-cols-1 gap-[28px] md:grid-cols-2 md:gap-y-[40px] md:gap-x-[24px] xl:grid-cols-4">
                    {program2023ImgList.map((img, i) => (
                        <li key={`img_${i}`}>
                            <Dialog>
                                <DialogTrigger asChild>
                                    <div className="cursor-pointer">
                                        <div className="group relative w-full h-0 pb-[67%] overflow-hidden transition-all duration-500 before:absolute before:content-[''] before:w-full before:h-full before:border-4 before:border-transparent before:[border-image:linear-gradient(135deg,#E64C88_0%,#3734C3_100%)_1] before:opacity-0 before:transition-all before:duration-500 before:z-[2] before:hover:opacity-100 hover:shadow-[0_0_36px_0_rgba(237,6,115,0.60)]">
                                            <img
                                                src={img.img}
                                                alt={img.title}
                                                className="absolute inset-0 z-[1] w-full h-full object-cover transition-all duration-500 group-hover:scale-[1.2]"
                                            />
                                        </div>
                                        <p className="text-[24px] text-black font-[600] pt-[16px]">{img.title}</p>
                                    </div>
                                </DialogTrigger>
                                <ImgPop title={img.title}>
                                    <ScrollArea className="max-h-[60vh]">
                                        <div className="p-[10px_20px_20px]">
                                            <img src={img.img} alt={img.title} />
                                        </div>
                                    </ScrollArea>
                                </ImgPop>
                            </Dialog>
                        </li>
                    ))}
                </ul>
            </section>
        </div>
    );
}
